/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';

import { UsersResolveRecipientsRequestDto } from '../../models/users-resolve-recipients-request-dto';
import { UsersResolveRecipientsResponseDto } from '../../models/users-resolve-recipients-response-dto';

export interface InternalNotificationsControllerResolveRecipients$Params {
      body: UsersResolveRecipientsRequestDto
}

export function internalNotificationsControllerResolveRecipients(http: HttpClient, rootUrl: string, params: InternalNotificationsControllerResolveRecipients$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersResolveRecipientsResponseDto>> {
  const rb = new UsersRequestBuilder(rootUrl, internalNotificationsControllerResolveRecipients.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as UsersStrictHttpResponse<UsersResolveRecipientsResponseDto>;
    })
  );
}

internalNotificationsControllerResolveRecipients.PATH = '/o2-users/internal/notifications/resolve-recipients';
